"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelsSpecialPricingRuleExpandedToJSON = exports.ModelsSpecialPricingRuleExpandedFromJSONTyped = exports.ModelsSpecialPricingRuleExpandedFromJSON = exports.instanceOfModelsSpecialPricingRuleExpanded = exports.ModelsSpecialPricingRuleExpandedStatusEnum = exports.ModelsSpecialPricingRuleExpandedTestPriceTypeEnum = exports.ModelsSpecialPricingRuleExpandedOrderTypeEnum = exports.ModelsSpecialPricingRuleExpandedGroupTypeEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.ModelsSpecialPricingRuleExpandedGroupTypeEnum = {
    Account: 'Account',
    Partnership: 'Partnership'
};
/**
 * @export
 */
exports.ModelsSpecialPricingRuleExpandedOrderTypeEnum = {
    Diagnostic: 'Diagnostic',
    StatTat: 'STAT-TAT',
    SmaStat: 'SMA-STAT',
    Carrier: 'Carrier',
    Nips: 'NIPS',
    Exome: 'Exome',
    ExomePreventiveAddOn: 'Exome Preventive Add-On',
    Preventive: 'Preventive',
    CombiPoc: 'Combi POC',
    CombiPfu: 'Combi PFU',
    CombiRpl: 'Combi RPL',
    CombiCdd: 'Combi CDD',
    CombiPd: 'Combi PD',
    CombiCc: 'Combi CC',
    Pharmacogenomics: 'Pharmacogenomics',
    SolidTumor: 'Solid Tumor',
    WholeGenomeSequencing: 'Whole Genome Sequencing'
};
/**
 * @export
 */
exports.ModelsSpecialPricingRuleExpandedTestPriceTypeEnum = {
    Oncology: 'Oncology',
    NonOncology: 'Non-Oncology',
    FvtVus: 'FVT/VUS',
    ReReq: 'Re-Req',
    PositiveFinding: 'Positive Finding',
    Standard: 'Standard',
    Partner: 'Partner',
    Donor: 'Donor',
    ProbandOnly: 'Proband-Only',
    Duo: 'Duo',
    Trio: 'Trio',
    CancerScreen: 'Cancer Screen',
    CardioScreen: 'Cardio Screen',
    GeneticHealthScreen: 'Genetic Health Screen',
    OtherScreen: 'Other Screen',
    CmaFollowUp: 'CMA Follow-Up',
    FishFollowUp: 'FISH Follow-Up',
    KaryotypeFollowUp: 'Karyotype Follow-Up',
    Cma: 'CMA',
    Fish: 'FISH',
    Karyotype: 'Karyotype',
    FragileX: 'Fragile X',
    Afp: 'AFP',
    AchE: 'AChE',
    Mcc: 'MCC',
    NipsWithMicrodeletions: 'NIPS With Microdeletions'
};
/**
 * @export
 */
exports.ModelsSpecialPricingRuleExpandedStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
};
/**
 * Check if a given object implements the ModelsSpecialPricingRuleExpanded interface.
 */
function instanceOfModelsSpecialPricingRuleExpanded(value) {
    var isInstance = true;
    isInstance = isInstance && "groupId" in value;
    isInstance = isInstance && "groupType" in value;
    isInstance = isInstance && "orderType" in value;
    isInstance = isInstance && "testPriceType" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
exports.instanceOfModelsSpecialPricingRuleExpanded = instanceOfModelsSpecialPricingRuleExpanded;
function ModelsSpecialPricingRuleExpandedFromJSON(json) {
    return ModelsSpecialPricingRuleExpandedFromJSONTyped(json, false);
}
exports.ModelsSpecialPricingRuleExpandedFromJSON = ModelsSpecialPricingRuleExpandedFromJSON;
function ModelsSpecialPricingRuleExpandedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ruleId': !(0, runtime_1.exists)(json, 'ruleId') ? undefined : json['ruleId'],
        'groupId': json['groupId'],
        'groupType': json['groupType'],
        'orderType': json['orderType'],
        'testPriceType': json['testPriceType'],
        'patientPrice': !(0, runtime_1.exists)(json, 'patientPrice') ? undefined : json['patientPrice'],
        'institutionPrice': !(0, runtime_1.exists)(json, 'institutionPrice') ? undefined : json['institutionPrice'],
        'thirdPartyProviderPrice': !(0, runtime_1.exists)(json, 'thirdPartyProviderPrice') ? undefined : json['thirdPartyProviderPrice'],
        'startDate': json['startDate'],
        'endDate': !(0, runtime_1.exists)(json, 'endDate') ? undefined : json['endDate'],
        'status': json['status'],
    };
}
exports.ModelsSpecialPricingRuleExpandedFromJSONTyped = ModelsSpecialPricingRuleExpandedFromJSONTyped;
function ModelsSpecialPricingRuleExpandedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ruleId': value.ruleId,
        'groupId': value.groupId,
        'groupType': value.groupType,
        'orderType': value.orderType,
        'testPriceType': value.testPriceType,
        'patientPrice': value.patientPrice,
        'institutionPrice': value.institutionPrice,
        'thirdPartyProviderPrice': value.thirdPartyProviderPrice,
        'startDate': value.startDate,
        'endDate': value.endDate,
        'status': value.status,
    };
}
exports.ModelsSpecialPricingRuleExpandedToJSON = ModelsSpecialPricingRuleExpandedToJSON;
